import { produce } from 'immer'
import {
  deactivateBillPayCardRouteProps,
  deactivateVirtualCardRouteProps,
} from 'src/navigation/routeProps'
import {
  PUT_VIRTUAL_CARD_CANCEL_FAILURE,
  PUT_VIRTUAL_CARD_CANCEL_INIT,
  PUT_VIRTUAL_CARD_CANCEL_SUCCESS,
  PutVirtualCardCancelActions,
} from 'src/redux/actions/data/virtualCards.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface DeactivateVirtualCardContentState {
  puttingVirtualCardCancel: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: DeactivateVirtualCardContentState = {
  puttingVirtualCardCancel: false,
}

export type Actions = PutVirtualCardCancelActions

const CoreDeactivateVirtualCardContentReducer = (
  state = initialState,
  action: Actions,
): DeactivateVirtualCardContentState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case PUT_VIRTUAL_CARD_CANCEL_INIT: {
        draft.puttingVirtualCardCancel = true
        return draft
      }

      case PUT_VIRTUAL_CARD_CANCEL_FAILURE: {
        draft.puttingVirtualCardCancel = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }

      case PUT_VIRTUAL_CARD_CANCEL_SUCCESS: {
        draft.puttingVirtualCardCancel = false
        return draft
      }
    }
  })
}

const DeactivateVirtualCardContentReducer = createFlyoutReducer(
  [deactivateVirtualCardRouteProps, deactivateBillPayCardRouteProps],
  initialState,
  CoreDeactivateVirtualCardContentReducer,
)

export default DeactivateVirtualCardContentReducer
